$(function () {
  const $header = $(".section-header");
  const $nav = $("nav.product-page-nav");
  const $navWrapper = $nav.find(".nav-wrapper");
  const $navList = $nav.find(".nav-list-content");
  const $navToggle = $nav.find(".nav-toggle");
  const $navArrow = $nav.find(".product-page-nav-icon-arrow");
  const $navLinks = $(".nav-list-content a");
  // 1. 滚动显示/隐藏导航
  function handleNavVisibility() {
    let headerBottom = $header.length
      ? $header.offset().top + $header.outerHeight()
      : 0;
    let scrollY = $(window).scrollTop();
    let visible = scrollY >= headerBottom;
    $nav.css({
      opacity: visible ? 1 : 0,
      "pointer-events": visible ? "auto" : "none",
    });
    // $nav.css("opacity", scrollY >= headerBottom ? 1 : 0);
  }

  $(window).on("scroll", handleNavVisibility);
  handleNavVisibility();

  // 2. 点击切换导航列表
  $navToggle.on("click", function (e) {
    e.stopPropagation();
    if ($navList.is(":hidden")) {
      $navList.css("display", "flex");
      $navWrapper.css("height", "auto");
      $navArrow.removeClass("svg-rotate");
    } else {
      $navList.css("display", "none");
      $navArrow.addClass("svg-rotate");
    }
  });

  // 3. 点击空白处关闭导航列表（仅移动端 <=1023px）
  $(document).on("click", function (e) {
    if (window.innerWidth <= 1023 && !$navList.is(":hidden")) {
      if (
        !$(e.target).closest($navList).length &&
        !$(e.target).closest($navToggle).length
      ) {
        $navList.hide();
        $navArrow.addClass("svg-rotate");
      }
    }
  });

  // 4. 可选：窗口尺寸变化时隐藏菜单（防止桌面切换移动端出现问题）
  $(window).on("resize", function () {
    if (window.innerWidth > 1023) {
      $navList.css("display", "");
      $navArrow.addClass("svg-rotate");
    }
  });

  var $sections = $();
  $navLinks.each(function () {
    var $target = $($(this).attr("href"));
    if ($target.length) {
      $sections = $sections.add($target);
    }
  });
  $navLinks.on("click", function (e) {
    e.preventDefault();
    var target = $($(this).attr("href"));
    $(window).scrollTop(target.offset().top - 60);
    if(window.innerWidth <= 1023 && !$navList.is(":hidden")) {
      $navList.hide();
      $navArrow.addClass("svg-rotate");
    }
  });
  $(window).on("scroll", function () {
    var scrollPos = $(document).scrollTop();
    if (scrollPos === 0) {
      $(".nav-highlight span").text("Highlight");
    }
    var currentId;
    $sections.each(function () {
      var sectionTop = $(this).offset().top - 70;
      if (scrollPos >= sectionTop) {
        currentId = $(this).attr("id");
        const navTitle = currentId.charAt(0).toUpperCase() + currentId.slice(1);
        $(".nav-highlight span").text(navTitle);
      }
    });

    $navLinks.removeClass("active");
    $navLinks.each(function () {
      if ($(this).attr("href") === "#" + currentId) {
        $(this).addClass("nav-active");
      } else {
        $(this).removeClass("nav-active");
      }
    });
  });
  $(window).trigger("scroll");
});
